import { attachComponentData } from '@backstage/core-plugin-api';
import { FIELD_EXTENSION_WRAPPER_KEY, FIELD_EXTENSION_KEY } from './keys.esm.js';

function createScaffolderFieldExtension(options) {
  return {
    expose() {
      const FieldExtensionDataHolder = () => null;
      attachComponentData(
        FieldExtensionDataHolder,
        FIELD_EXTENSION_KEY,
        options
      );
      return FieldExtensionDataHolder;
    }
  };
}
const ScaffolderFieldExtensions = () => null;
attachComponentData(
  ScaffolderFieldExtensions,
  FIELD_EXTENSION_WRAPPER_KEY,
  true
);

export { ScaffolderFieldExtensions, createScaffolderFieldExtension };
//# sourceMappingURL=createScaffolderFieldExtension.esm.js.map
